
/* injects from baggage-loader */

'use strict';

export default class InvestmentListItemController {

	constructor($log, $interval, User) {
		'ngInject';

		this.$log = $log;
		this.$interval = $interval;
		this.User = User;

		this.editing = false;

	}

	$onInit() {
		this.$log.log('Index:', this.index, this.title)
	}


	/**
	 * Returns true when the current user is the owner of the project
	 */
	isProjectOwner() {
		let currentUser = this.User.getCurrent();
		let ACL = this.project.getACL();
		if (currentUser && ACL) {
			return ACL.getWriteAccess(currentUser.id);
		}
	}


	/**
	 * Toggle the editing state of this info panel
	 */
	toggleEdit() { 
		this.editing = !this.editing;

		// Start watching editing
		if (this.editing) {
			this.editingWatcher = this.$interval(() => {
				if (this.isEditingProject === false && this.editing) {
					this.toggleEdit();
				}
			}, 100);
		} else {
			this.$interval.cancel(this.editingWatcher);
		}

	}

	delete() {

		// Confirm deletion of section
		this.$log.log('Delete section:', this.index, this.title);
		this.$log.log(this.deleteSection);

		if (typeof this.deleteSection === 'function') {
			this.deleteSection(this.index);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/investmentListItem/investmentlistitem.controller.js